<template>
  <div>
    <div class="group-input col-12 column q-mt-sm">
      <RequiredLabel
        v-if="isFieldRequiredByAtendimento('HFC') || typeOs === BACKBONE_MDU_PROBLEMA_SAR"
        title="Número do Incidente"
        name="numero_do_incidente"
      />
      <label
        for="numer_do_incidente"
        v-else
        >Número do incidente</label
      >
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        type="number"
        color="red-9"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        v-model="itemOsContract.numero_do_incidente"
        bg-color="white"
        lazy-rules
        name="numero_do_incidente"
        :rules="
          typeOs === BACKBONE_MDU_PROBLEMA_SAR || isFieldRequiredByAtendimento('HFC')
            ? [(val) => !!val || 'Campo Obrigatório']
            : ''
        "
      />
    </div>
    <div
      class="group-input col-12 row q-mt-sm"
      v-if="typeOs !== REDE_EXTERNA_PROBLEMA"
    >
      <RequiredLabel
        title="Valor do TAP"
        name="valor_do_tap"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        v-model="itemOsContract.valor_do_tap"
        bg-color="white"
        lazy-rules
        name="valor_do_tap"
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <ExternalNetworkProblemForm
      v-if="typeOs === REDE_EXTERNA_PROBLEMA"
      :itemOsContract="itemOsContract"
      :isCityBrownFieldOrGpon="isCityBrownFieldOrGpon"
    />
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Canal Alto"
        name="canal_alto"
        v-if="typeOs === BACKBONE_MDU_PROBLEMA_SAR || isFieldRequiredByAtendimento('HFC')"
      />
      <label
        for="canal_alto"
        v-else
        >Canal Alto</label
      >
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        v-model="itemOsContract.canal_alto"
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        name="canal_alto"
        lazy-rules
        :rules="
          typeOs === BACKBONE_MDU_PROBLEMA_SAR || isFieldRequiredByAtendimento('HFC')
            ? [(val) => !!val || 'Campo Obrigatório']
            : ''
        "
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Canal Baixo"
        name="canal_baixo"
        v-if="typeOs === BACKBONE_MDU_PROBLEMA_SAR || isFieldRequiredByAtendimento('HFC')"
      />
      <label
        for="canal_baixo"
        v-else
        >Canal Baixo</label
      >
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        v-model="itemOsContract.canal_baixo"
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        name="canal_baixo"
        :rules="
          typeOs === BACKBONE_MDU_PROBLEMA_SAR || isFieldRequiredByAtendimento('HFC')
            ? [(val) => !!val || 'Campo Obrigatório']
            : ''
        "
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="TX: Nível de sinal para Virtua e Voip"
        name="tx_nivel_sinal"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        v-model="itemOsContract.tx_nivel_sinal"
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        name="tx_nivel_sinal"
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="RX: Nível de sinal para Virtua e Voip"
        name="rx_nivel_sinal"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        v-model="itemOsContract.rx_nivel_sinal"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        name="rx_nivel_sinal"
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="PS QS: Níveis de sinal"
        name="ps_qs_niveis_sinal"
        v-if="typeOs === BACKBONE_MDU_PROBLEMA_SAR || isFieldRequiredByAtendimento('HFC')"
      />
      <label
        for="ps_qs_niveis_sinal"
        v-else
        >PS QS: Níveis de sinal</label
      >
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        v-model="itemOsContract.ps_qs_niveis_sinal"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        name="ps_qs_niveis_sinal"
        :rules="
          typeOs === BACKBONE_MDU_PROBLEMA_SAR || isFieldRequiredByAtendimento('HFC')
            ? [(val) => !!val || 'Campo Obrigatório']
            : ''
        "
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="BER: Nível de sinal"
        name="ber_nivel_sinal"
        v-if="typeOs === BACKBONE_MDU_PROBLEMA_SAR || isFieldRequiredByAtendimento('HFC')"
      />
      <label
        for="ber_nivel_sinal"
        v-else
        >BER: Nível de sinal</label
      >
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        v-model="itemOsContract.ber_nivel_sinal"
        color="red-9"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        name="ber_nivel_sinal"
        :rules="
          typeOs === BACKBONE_MDU_PROBLEMA_SAR || isFieldRequiredByAtendimento('HFC')
            ? [(val) => !!val || 'Campo Obrigatório']
            : ''
        "
      />
    </div>
    <div
      class="group-input col-12 row q-mt-sm"
      v-if="typeOs === REDE_EXTERNA_PROBLEMA"
    >
      <RequiredLabel
        title="Potência Ótica"
        name="potencia_otica"
        v-if="isFieldRequiredByAtendimento('GPON')"
      />
      <label
        v-else
        for="potencia_otica"
        >Potência Ótica</label
      >
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        v-model="itemOsContract.potencia_otica"
        color="red-9"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        name="potencia_otica"
        :rules="
          isFieldRequiredByAtendimento('GPON') && [
            (val) => !!val || 'Campo Obrigatório',
          ]
        "
      />
    </div>
  </div>
</template>

<script>
  import { BACKBONE_MDU_PROBLEMA_SAR, REDE_EXTERNA_PROBLEMA } from "@/utils/constans/specialCodes";
import { inject, onBeforeMount, provide } from "vue";
import ExternalNetworkProblemForm from "./Forms/ExternalNetworkProblemForm.vue";
import RequiredLabel from "./RequiredLabel.vue";

  export default {
    name: "ServiceInfoForm",
    components: {
      ExternalNetworkProblemForm,
      RequiredLabel,
    },
    props: {
      itemOsContract: Object,
      typeOs: Number,
      addFieldsToSchema: Function,
      cityDetails: Object,
    },

    setup(props, { emit }) {
      const defaultServiceInfoFields = {
        canal_alto: "",
        canal_baixo: "",
        tx_nivel_sinal: "",
        rx_nivel_sinal: "",
        ps_qs_niveis_sinal: "",
        ber_nivel_sinal: "",
      };

      let exeternalNetworkFields = {
        ...defaultServiceInfoFields,
        rede_energizada: 0,
        rede_cordoalha_energizada: "",
        numero_do_incidente: "",
        valor_tap_nap: "",
        nome_nap: "",
        porta_nap: "",
        endereco_nap: "",
        casas_conectadas_nap: "",
        potencia_otica: "",
      };

      let backboneMduFields = {
        ...defaultServiceInfoFields,
        valor_do_tap: "",
      };

      const isFieldRequiredByAtendimento = (type) => {
        const atendimento = props.cityDetails.atendimento;

        const formattedAtendimento = atendimento.split("/");
        const isMatchAtendimento = formattedAtendimento.some(
          (item) => item.trim().toUpperCase() === type.toUpperCase()
        );

        return props.typeOs === REDE_EXTERNA_PROBLEMA && isMatchAtendimento;
      };

      provide("isFieldRequiredByAtendimento", isFieldRequiredByAtendimento);

      onBeforeMount(() => {
        const newFields =
          props.typeOs === REDE_EXTERNA_PROBLEMA ? exeternalNetworkFields : backboneMduFields;

        const addFieldsToRequestData = inject("addFieldsToRequestData");

        addFieldsToRequestData(newFields);
      });

      return {
        isFieldRequiredByAtendimento,
        BACKBONE_MDU_PROBLEMA_SAR, 
        REDE_EXTERNA_PROBLEMA,
      };
    },
  };
</script>

<style scoped lang="scss">
  label {
    font-family: Roboto;
    font-style: normal;
  }
  .group-input {
    label {
      font-weight: bold;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.4);
    }
  }
</style>
